module.exports = __webpack_public_path__ + "static/media/spinner.02f1d4be.gif";